import Vue from "vue";
import { isSandbox } from "../utils/tools";
import { getOsVersion } from "../utils/util";

/**
 * 需要过滤的message的列表
 * @type {string[]}
 */
const filterMsgList: any[] = ["即将跳转登录", "请求参数失败", "setItem"];

/**
 * 判断是否包含需要过滤的message信息
 * @param message
 * @returns {boolean}
 */
function includeFilterMsg(message: any) {
    if (typeof message !== "string") return false;

    // return filterMsgList.some(msg => message.includes(msg));
    try {
        for (let i = 0; i < filterMsgList.length; i++) {
            const match = !!message.match(filterMsgList[i]);
            if (match) return true;
        }
        return false;
    } catch (e) {
        // 防止极限情况下，连match都不支持的情况。
        return false;
    }
}

if (!isSandbox()) {
    try {
        (window as any).BJ_REPORT.init({
            id: 45, // project_code
            uin: "yiqiwen-live", // 用户标识
            url: "//error.youjyi.cn/api/errrorlog/receive", // 上报url
            random: 1, // 抽样上报
            offlineLog: false, // 是否离线上报
            onReport: function(id: number, errObj: any) {
                // 上报回调
            },
        });
    } catch (error) {
        console.log(error);
    }
}

Vue.config.errorHandler = function(err: any, vm, info) {
    let { message, name, script, line, column, stack } = err;
    script = script !== undefined ? script : "";
    line = line !== undefined ? line : 0;
    column = column !== undefined ? line : 0;
    let stackStr =
        (stack && stack.toString()) ||
        (name !== undefined &&
            message !== undefined &&
            name !== "undefined" &&
            message !== "undefined" &&
            `${name}:${message}`) ||
        err;
    console.log("stackStr:" + stackStr);

    try {
        if (!isSandbox() && stackStr) {
            // 判断是否包含需要过滤的错误信息
            const includeFilter = includeFilterMsg(stackStr);
            if (includeFilter) return;

            let osVersion = getOsVersion();
            if (
                osVersion.indexOf("Android") > -1 &&
                Number(osVersion.slice(7, 8)) < 6
            ) {
                return;
            }
            (window as any).BJ_REPORT &&
                (window as any).BJ_REPORT.report({
                    msg: stackStr,
                    from: window.location.href,
                    target: script,
                    rowNum: line,
                    colNum: column,
                });
        }
    } catch (error) {
        console.log(error);
    }
};
